import React from 'react';
import AdminLayout from '../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../components/common/Containers/DashboardMainContainer';
import {
  AdminAlertText,
  AdminDetailFieldLabel,
  AdminDetailFieldValue,
  AdminHeaderAction,
  AdminPageTitle,
  AdminPanelTitle,
  AdminRowAction,
  AdminSupportingText,
  AdminTableHeader,
  adminFilterDateInputClasses,
  adminFilterDropdownTriggerClass,
  ADMIN_TABLE_CLASS,
} from '../shared/adminUx';


/** Placeholder shell for configuration hubs until feature UI is built */
const ConfigurationHubPlaceholder = ({ title }) => (
  <AdminLayout>
    <div className="min-w-0">
      <AdminPageTitle>{title}</AdminPageTitle>
      <DashboardMainContainer className={`${ADMIN_TABLE_CLASS} max-w-full min-w-0`}>
        <AdminSupportingText className="text-mediumgray">
          Configuration for {title} will appear here.
        </AdminSupportingText>
      </DashboardMainContainer>
    </div>
  </AdminLayout>
);

export default ConfigurationHubPlaceholder;
